class CountdownTimer extends HTMLElement {
    /**
     * Target date for the countdown
     * 
     * @type {number}
     */
    targetDate;

    /**
     * Countdown elements
     * 
     * @type {Object}
     */
    countdownElements;

    constructor() {
        super();

        // Initialize countdownElements directly
        this.countdownElements = {
            daysTens: this.querySelector('#times_day_tens'),
            daysOnes: this.querySelector('#times_day_ones'),
            hoursTens: this.querySelector('#times_hour_tens'),
            hoursOnes: this.querySelector('#times_hour_ones'),
            minutesTens: this.querySelector('#times_minute_tens'),
            minutesOnes: this.querySelector('#times_minute_ones'),
            secondsTens: this.querySelector('#times_second_tens'),
            secondsOnes: this.querySelector('#times_second_ones'),
            daysOnesSymbol:this.querySelector('#times_day_ones_symbol'),
            countdownText: this.querySelector('.components-countdown-text'),
            countdownItem: this.querySelector('.components-countdown-time_items')
        };

        // Initialize targetDate from data-date attribute
        this.targetDate = new Date(this.getAttribute("data-date")).getTime();
        this.targetCycle = Math.floor(this.getAttribute("data-cycle")) || 0;
        this.targetEndTip = this.getAttribute("data-endtip") || "Oops! It's over!";
        this.targetDayToHours = this.getAttribute("data-daytohours") === 'true' ? true : false;
       
        this.updateCountdown();

        // Update every second
        setInterval(() => this.updateCountdown(), 1000);
    }

    updateCountdown() {
        const now = new Date().getTime();
        const endtime = this.targetDate;
        const timeRemaining = endtime - now;

        if (timeRemaining <= 0) {           
            // Countdown is over
            if(this.targetCycle >0){
                const cycle_time = 24 * 60 * 60 * 1000 * this.targetCycle;
                const time_distance = Math.floor(now - endtime);
                const left_time = time_distance % cycle_time
                const time = now + (cycle_time - left_time);
                this.continiuCountdown(time);
            }
                
            else{
              this.resetCountdown();
            }

        } else {
            this.continiuCountdown(this.targetDate);
        }
    }

    updateElement(element, value) {
        if (element) {
            element.textContent = value;
        }
    }

    resetCountdown() {
        // Countdown is over
        for (const key in this.countdownElements) {
            this.updateElement(this.countdownElements[key], '0');
            
        }
        this.countdownElements.countdownItem.style.display = 'none';
        this.updateElement(this.countdownElements.countdownText, this.targetEndTip);
    }

    continiuCountdown(time){
        const now = new Date().getTime();
        const endtime = time;
        const timeRemaining = endtime - now;
        // Calculate remaining days, hours, minutes, and seconds
        const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

        // Update countdown elements
        if(this.targetDayToHours && days > 0) {
            let total_hours = days * 24 + hours;
            this.updateElement(this.countdownElements.hoursTens, total_hours > 99 ? '9' : Math.floor(total_hours / 10).toString());
            this.updateElement(this.countdownElements.hoursOnes, total_hours > 99 ? '9' : (total_hours % 10).toString());
        } else {
            this.updateElement(this.countdownElements.daysTens, days > 0 ? Math.floor(days / 10).toString() : '0');
            this.updateElement(this.countdownElements.daysOnes, (days % 10).toString());
            this.updateElement(this.countdownElements.hoursTens, Math.floor(hours / 10).toString());
            this.updateElement(this.countdownElements.hoursOnes, (hours % 10).toString());
        }
        this.updateElement(this.countdownElements.minutesTens, Math.floor(minutes / 10).toString());
        this.updateElement(this.countdownElements.minutesOnes, (minutes % 10).toString());
        this.updateElement(this.countdownElements.secondsTens, Math.floor(seconds / 10).toString());
        this.updateElement(this.countdownElements.secondsOnes, (seconds % 10).toString());

        // Hide daysTensElement if days is 0
        this.countdownElements.daysTens.style.display = days > 0 ? 'inline-block' : 'none';
        this.countdownElements.daysOnes.style.display = days > 0 ? 'inline-block' : 'none';
        if( days == 0 || this.targetDayToHours == true){
            this.countdownElements.daysOnesSymbol.style.display = 'none';
            if(this.countdownElements.daysOnesSymbol.parentNode) {
                this.countdownElements.daysOnesSymbol.parentNode.style.display = 'none';
            }
        }
    }
}

// Use custom element tag name without a dot
customElements.define('countdown-timer', CountdownTimer);
